export enum TaskType {
    General = 1,
    Service = 2,
    Lab = 3,
    Radiology = 4,
    Medical = 5
}
